/*
 * pdp-accordion.js — aidabicaj.com
 * Turns the below-split description tabs (ul.tabs + ul.tabs-content, "P50 template")
 * into <details> accordions inside [data-pdp-accordions]. Loaded right after that
 * container, so it runs before first paint (no tab -> accordion jump).
 *
 * Self-contained: never throws. If the markup doesn't match, the original tabs are
 * left untouched and the theme's own tab script handles them as before.
 */
(function () {
  try {
    var roots = document.querySelectorAll('[data-pdp-accordions]:not([data-pdp-built])');

    Array.prototype.forEach.call(roots, function (root) {
      try {
        var openFirst = root.getAttribute('data-open-first') !== 'false';
        var nav = root.querySelector('ul.tabs');
        var panelsWrap = root.querySelector('ul.tabs-content');

        if (!nav || !panelsWrap) {
          root.setAttribute('data-pdp-built', 'no-tabs');
          return;
        }

        var panels = Array.prototype.filter.call(panelsWrap.children, function (el) {
          return el.tagName === 'LI';
        });
        var links = nav.querySelectorAll('a');
        var items = [];

        Array.prototype.forEach.call(links, function (a, i) {
          var target = a.getAttribute('aria-controls') ||
            (a.getAttribute('href') || '').replace(/^#/, '');
          var panel = null;

          if (target) {
            panel = panels.filter(function (p) { return p.id === target; })[0] || null;
          }
          if (!panel) panel = panels[i] || null;

          var label = (a.textContent || '').trim();
          if (panel && label) items.push({ label: label, panel: panel });
        });

        if (!items.length) {
          root.setAttribute('data-pdp-built', 'no-match');
          return;
        }

        var frag = document.createDocumentFragment();

        items.forEach(function (item, i) {
          var details = document.createElement('details');
          details.className = 'collapsible-tab pdp-acc';
          if (openFirst && i === 0) details.open = true;

          var summary = document.createElement('summary');
          summary.className = 'collapsible-tab__heading';
          var span = document.createElement('span');
          span.textContent = item.label;
          summary.appendChild(span);

          var body = document.createElement('div');
          body.className = 'collapsible-tab__text pdp-acc__body rte';
          while (item.panel.firstChild) body.appendChild(item.panel.firstChild);

          details.appendChild(summary);
          details.appendChild(body);
          frag.appendChild(details);
        });

        nav.parentNode.insertBefore(frag, nav);
        nav.parentNode.removeChild(nav);
        panelsWrap.parentNode.removeChild(panelsWrap);
        root.setAttribute('data-pdp-built', 'true');
      } catch (err) {
        root.setAttribute('data-pdp-built', 'error');
        if (window.console) console.warn('[pdp-accordion]', err);
      }
    });
  } catch (err) {
    if (window.console) console.warn('[pdp-accordion]', err);
  }
})();
